import React, { useRef, MouseEvent } from 'react';
import './ProductImageZoom.css';
import { ProductImageZoomProps } from '../../Interface/Product.interface';

const ProductImageZoom: React.FC<ProductImageZoomProps> = ({ image }) => {
  const imgRef = useRef<HTMLImageElement | null>(null);

  const handleMouseMove = (e: MouseEvent<HTMLDivElement>) => {
    const target = e.currentTarget;
    const { left, top, width, height } = target.getBoundingClientRect();
    const x = ((e.pageX - left) / width) * 100;
    const y = ((e.pageY - top) / height) * 100;

    if (imgRef.current) {
      imgRef.current.style.transformOrigin = `${x}% ${y}%`;
    }
  };

  const handleMouseLeave = () => {
    if (imgRef.current) {
      imgRef.current.style.transformOrigin = 'center center';
    }
  };

  return (
    <div
      className="zoom-container"
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
    >
      <img ref={imgRef} className="zoom-image" src={`data:image/jpeg;base64,${image}`} alt="Product" />
    </div>
  );
};

export default ProductImageZoom;
